"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Messenger = require("./Messenger");

var _Link = _interopRequireDefault(require("../../Link"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MESSENGERS = [{
  name: 'WhatsApp',
  type: _Messenger.TYPES.WHATSAPP,
  link: 'https://api.whatsapp.com/send?phone=79150424411',
  bgColor: '58, 222, 88'
}, {
  name: 'VK',
  type: _Messenger.TYPES.VK,
  link: 'https://vk.com/im?sel=-29855322',
  bgColor: '39, 135, 245'
}, {
  name: 'Telegram',
  type: _Messenger.TYPES.TELEGRAM_WITHOUT_BG,
  link: 'https://telegram.me/LevelTravelChatBot',
  bgColor: '51, 169, 228'
} // {
//   name: 'Facebook',
//   type: TYPES.FACEBOOK,
//   link: 'https://www.facebook.com/messages/t/293609120687915',
// },
];

var FeedbackMessengers = function FeedbackMessengers(_ref) {
  var isMobile = _ref.isMobile;
  return /*#__PURE__*/_react["default"].createElement(MessengersList, {
    $isMobile: isMobile
  }, MESSENGERS.map(function (messenger) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: messenger.name
    }, /*#__PURE__*/_react["default"].createElement(MessengerLink, {
      href: messenger.link,
      $bgColor: messenger.bgColor,
      $isMobile: isMobile
    }, /*#__PURE__*/_react["default"].createElement(MessengerIcon, {
      type: messenger.type
    }), /*#__PURE__*/_react["default"].createElement(MessengerName, null, messenger.name)));
  }));
};

var MessengersList = _styledComponents["default"].ul.withConfig({
  displayName: "FeedbackMessengers__MessengersList",
  componentId: "sc-626d29-0"
})(["display:flex;max-width:400px;justify-content:space-between;margin:30px auto 0 auto;", ""], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["flex-direction:column;width:100%;"]);
});

var MessengerIcon = (0, _styledComponents["default"])(_Messenger.Messenger).withConfig({
  displayName: "FeedbackMessengers__MessengerIcon",
  componentId: "sc-626d29-1"
})(["margin-right:8px;width:46px;height:38px;"]);

var MessengerName = _styledComponents["default"].div.withConfig({
  displayName: "FeedbackMessengers__MessengerName",
  componentId: "sc-626d29-2"
})(["font-size:18px;display:flex;align-items:center;"]);

var MessengerLink = (0, _styledComponents["default"])(_Link["default"]).withConfig({
  displayName: "FeedbackMessengers__MessengerLink",
  componentId: "sc-626d29-3"
})(["color:#000;padding:8px;position:relative;vertical-align:top;display:flex;background:", ";margin:4px 8px;border-radius:8px;", " &:hover{background:", ";transition:all 0.3s;}"], function (_ref3) {
  var $bgColor = _ref3.$bgColor;
  return "rgba(".concat($bgColor, ",0.2)");
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["justify-content:center;"]);
}, function (_ref5) {
  var $bgColor = _ref5.$bgColor;
  return "rgba(".concat($bgColor, ",0.4)");
});
var _default = FeedbackMessengers;
exports["default"] = _default;